import { render, staticRenderFns } from "./RsLabel.vue?vue&type=template&id=48924216&"
import script from "./RsLabel.vue?vue&type=script&lang=tsx&"
export * from "./RsLabel.vue?vue&type=script&lang=tsx&"
import style0 from "./RsLabel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports